import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

// 辅助函数：递归从 IB 节点及其 children 中移除 tag
const removeTagFromIBNode = (node, contactId, tagId) => {
  if (node.id === contactId) {
    // 这是 IB 本人行
    return {
      ...node,
      tags: node.tags ? node.tags.filter(tag => tag.id !== parseInt(tagId, 10)) : [],
    };
  }

  // 递归处理 children
  if (node.children && node.children.length > 0) {
    const updatedChildren = node.children.map(child => {
      if (child.node_type === 'ib') {
        return removeTagFromIBNode(child, contactId, tagId);
      }
      if (child.id === contactId) {
        return {
          ...child,
          tags: child.tags ? child.tags.filter(tag => tag.id !== parseInt(tagId, 10)) : [],
        };
      }
      return child;
    });
    return { ...node, children: updatedChildren };
  }

  return node;
};

export const initialState = {
  isGetClientLoading: false,
  selectedContactsIds: [],

  contactsExportDataIsLoaded: false,
  contactsExportData: {},

  contacts: {},
  contactsAreLoaded: false,

  favorites: [],
  favoritesAreLoaded: false,

  crmFilterIsLoaded: false,
  crmFilter: {},

  // 添加新状态以存储上传结果
  uploadContactsResult: null,

  ibTree: { results: [], count: 0 },
  ibTreeIsLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CONTACTS_EXPORTS[REQUEST]:
      return { ...state, contactsExportDataIsLoaded: false };
    case ActionTypes.GET_CONTACTS_EXPORTS[SUCCESS]:
      return { ...state, contactsExportData: action.data, contactsExportDataIsLoaded: true };
    case ActionTypes.GET_CONTACTS_EXPORTS[FAILURE]:
      return { ...state, error: action.error, userExportDataIsLoaded: false };
    case ActionTypes.CRM_SET_SELECTED_CONTACTS_IDS: {
      return { ...state, selectedContactsIds: action.data };
    }
    case ActionTypes.GET_CONTACTS[REQUEST]:
      return { ...state, contactsAreLoaded: false };
    case ActionTypes.GET_CONTACTS[SUCCESS]:
      return { ...state, contacts: action.data, contactsAreLoaded: true };
    case ActionTypes.GET_CONTACTS[FAILURE]:
      return { ...state, error: action.error, contactsAreLoaded: false };

    case ActionTypes.GET_CRM_CLIENT[REQUEST]:
      return { ...state, isGetClientLoading: false };
    case ActionTypes.GET_CRM_CLIENT[SUCCESS]:
      return { ...state, isGetClientLoading: true };
    case ActionTypes.GET_CRM_CLIENT[FAILURE]:
      return { ...state, isGetClientLoading: false };

    case ActionTypes.GET_CONTACTS_FAVORITES[REQUEST]:
      return { ...state, favoritesAreLoaded: false };
    case ActionTypes.GET_CONTACTS_FAVORITES[SUCCESS]:
      return { ...state, favorites: action.data, favoritesAreLoaded: true };
    case ActionTypes.GET_CONTACTS_FAVORITES[FAILURE]:
      return { ...state, error: action.error, favoritesAreLoaded: false };

    case ActionTypes.GET_CRM_FILTER[REQUEST]:
      return { ...state, crmFilterIsLoaded: false };
    case ActionTypes.GET_CRM_FILTER[SUCCESS]:
      return { ...state, crmFilterIsLoaded: true, crmFilter: action.data };
    case ActionTypes.GET_CRM_FILTER[FAILURE]:
      return { ...state, error: action.error, crmFilterIsLoaded: false };

    // 添加对 UPLOAD_CONTACTS action 的处理
    case ActionTypes.UPLOAD_CONTACTS[REQUEST]:
      return { ...state, uploadContactsResult: null };
    case ActionTypes.UPLOAD_CONTACTS[SUCCESS]:
      return { ...state, uploadContactsResult: action.data };
    case ActionTypes.UPLOAD_CONTACTS[FAILURE]:
      return { ...state, error: action.error };

    // 在reducer函数的switch语句中添加一个新的case

    case ActionTypes.CLEAR_UPLOAD_CONTACTS_RESULT:
      return { ...state, uploadContactsResult: null };

    case ActionTypes.GET_CONTACTS_IB_TREE[REQUEST]:
      return { ...state, ibTreeIsLoaded: false };
    case ActionTypes.GET_CONTACTS_IB_TREE[SUCCESS]:
      return { ...state, ibTree: action.data, ibTreeIsLoaded: true };
    case ActionTypes.GET_CONTACTS_IB_TREE[FAILURE]:
      return { ...state, error: action.error, ibTreeIsLoaded: false };

    // 删除标签后更新 ibTree 中的 tags
    case ActionTypes.DELETE_CONTACT_TAG[SUCCESS]: {
      const { id, tagId } = action.data;
      const newIbTree = { ...state.ibTree };

      // 在 results 中找到对应的 contact 并移除 tag
      const updatedResults = newIbTree.results.map(node => {
        if (node.node_type === 'ib') {
          // IB 节点，需要递归检查
          const updatedNode = removeTagFromIBNode(node, id, tagId);

          return updatedNode;
        }
        if (node.id === id) {
          // 普通用户节点
          return {
            ...node,
            tags: node.tags ? node.tags.filter(tag => tag.id !== parseInt(tagId, 10)) : [],
          };
        }
        return node;
      });

      newIbTree.results = updatedResults;
      return { ...state, ibTree: newIbTree };
    }

    default:
      return state;
  }
};

export default reducer;
